import { createContext, useContext, useState } from "react";
import http from "../helpers/http";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "./AuthContext";
import { decodeToken } from "react-jwt";

export const Authprovider = ({ children }) => {
  const [user, setUser] = useState(() => {
    // Load user data from local storage upon component initialization
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : {};
  });
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [userrole, setUserRole] = useState(() => {
    const storedRole = localStorage.getItem("role");
    return storedRole ? JSON.parse(storedRole) : {};
  });
  const navigate = useNavigate();

  const login = async (email, password, tenant) => {
    setLoading(true);
    try {
      let response;
      if (!tenant) {
        response = await http().post("/Account/Login", {
          username: email,
          password: password,
        });
      } else {
        response = await http(true).post("/Organisation/login", {
          username: email,
          password: password,
          tenant: tenant,
        });
      }

      if (response.data) {
        //const decodedRole = decodeToken(response.data.data.accessToken);
        localStorage.setItem("token", response.data.data.accessToken);
        localStorage.setItem("user", JSON.stringify(response.data.data));
        setIsLoggedIn(true);

        setUserRole(decodeToken(response.data.data.accessToken));
        localStorage.setItem(
          "role",
          JSON.stringify(decodeToken(response.data.data.accessToken))
        );
        setUser(response.data.data);
        setToken(response.data.data.accessToken);
        setLoading(false);
        navigate("/dashboard");
        // if (decodedRole.role === "Business Support User") {
        //   navigate("/merchants");
        // } else {
        //   navigate("/dashboard");
        // }
      }
    } catch (error) {
      if (error.response) {
        setLoading(false);
        toast.error(error.response.data.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("role");
    navigate("/");
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        logout,
        setUser,
        isLoggedIn,
        token,
        loading,
        userrole,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
